<template>
    <div class="homePageBox">
        <div class="homePageContent">
            <div class="pageLeft">
                <!--基础信息-->

                <!--生意参谋-->

                <!--销量排行-->

            </div>
            <div class="pageRight">
                <!--待办任务-->

                <!--结算中心-->

                <!--店铺概况-->
            </div>
        </div>
        <!--<div class="footer">
            <p>
                <span>帮助</span>
                <span>隐私</span>
                <span>条款</span>
            </p>
            <p>copyright © 2021 安徽增材云数字科技有限公司</p>
        </div>-->
    </div>
</template>

<script>
import { findProvidersInfo,findMaterialCount,getVolumeCount,getPrintEnterPriseInfo,
    getPrintAndShopOrderCount,getSellerOrderPosition,getPayOrderInfo,
    findServiceabilityCount,findStoreFollowCount } from '../../utils/interface';
export default {
    name: "homePage",
    data(){
        return {
            uuid: '',
            enterPriseId: '',
            materialCount: 0,
            serviceabilityCount: 0,
            storeFollowCount: 0,
            confirmCount:0,
            afterCount:0,
            appraiseCount:0,
            payCount:0,
            sendCount:0,
            printList:[],
            userMessages:{},
            authorities:"",
            providerCount:0,
            serviceCount:0,
            yesterdayProviderCount:0,
            yesterdayServiceCount:0,
            userCount:0,
            visitorCount:0,
            yesterdayUserCount:0,
            yesterdayVisitorCount:0,
            nowDate:"",
            payOrderCount:0,
            payOrderPrice:0,
            yesterdayPayOrderCount:0,
            yesterdayPayOrderPrice:0,
            storeInfo:"",
            enterPriseInfo:{},
        }
    },
    mounted() {
        setTimeout(() => {
            this.setNowTimes();
        }, 500);
    },
    created(){
        //this.getPrintEnterPriseInfo();
        //this.findMaterialCount();
        //this.findServiceabilityCount();
        //this.findStoreFollowCount();
        //this.getPrintAndShopOrderCount();
        //this.getSellerOrderPosition();
        //this.getVolumeCount();
        //this.getPayOrderInfo();
    },
    methods: {
        // 订单金额
        getPayOrderInfo(){
            getPayOrderInfo().then((res)=>{
                if(res&&res.data){
                    this.payOrderPrice = res.data.orderPrice==null?0:res.data.orderPrice;
                    this.payOrderCount = res.data.orderCount==null?0:res.data.orderCount;
                    this.yesterdayPayOrderPrice = res.data.yesterdayOrderPrice==null?0:res.data.yesterdayOrderPrice;
                    this.yesterdayPayOrderCount = res.data.yesterdayOrderCount==null?0:res.data.yesterdayOrderCount;
                }
            });
        },
        // 当前时间
        setNowTimes(){
            let myDate = new Date();
            let yy = String(myDate.getFullYear());
            let mm = myDate.getMonth() + 1;
            let dd = String(
                myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate()
            );
            let hou = String(
                myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours()
            );
            let min = String(
                myDate.getMinutes() < 10
                    ? "0" + myDate.getMinutes()
                    : myDate.getMinutes()
            );
            let sec = String(
                myDate.getSeconds() < 10
                    ? "0" + myDate.getSeconds()
                    : myDate.getSeconds()
            );
            this.nowDate = yy + "年" + mm + "月" + dd + "日" + hou + ":" + min + ":" + sec;
        },
        // 浏览量
        getVolumeCount(){
            getVolumeCount().then((res)=>{
                if(res&&res.data){
                    this.providerCount = res.data.allProviderCount==null?0:res.data.allProviderCount;
                    this.serviceCount = res.data.allServiceCount==null?0:res.data.allServiceCount;
                    this.yesterdayProviderCount = res.data.yesterdayProviderCount==null?0:res.data.yesterdayProviderCount;
                    this.yesterdayServiceCount = res.data.yesterdayServiceCount==null?0:res.data.yesterdayServiceCount;
                    this.visitorCount = res.data.visitorCount==null?0:res.data.visitorCount;
                    this.userCount = res.data.userCount==null?0:res.data.userCount;
                    this.yesterdayVisitorCount = res.data.yesterdayVisitorCount==null?0:res.data.yesterdayVisitorCount;
                    this.yesterdayUserCount = res.data.yesterdayUserCount==null?0:res.data.yesterdayUserCount;
                }
            });
        },
        // 订单排行
        getSellerOrderPosition(){
            getSellerOrderPosition().then((res)=>{
                if(res&&res.data){
                    this.printList = res.data;
                }
            });
        },
        // 订单数
        getPrintAndShopOrderCount(){
            getPrintAndShopOrderCount().then((res)=>{
                if(res&&res.data){
                    this.confirmCount = res.data.confirmCount==null?0:res.data.confirmCount;
                    this.afterCount = res.data.afterCount==null?0:res.data.afterCount;
                    this.appraiseCount = res.data.appraiseCount==null?0:res.data.appraiseCount;
                    this.payCount = res.data.payCount==null?0:res.data.payCount;
                    this.sendCount = res.data.sendCount==null?0:res.data.sendCount;
                }
            });
        },
        // 服务商详情页
        handleDesigner(){
            window.open(
                this.$url.threeWeb + '/printServiceIndex' + this.uuid + this.enterPriseId ,
                "_blank"
            );
        },
        getPrintEnterPriseInfo(){
            getPrintEnterPriseInfo().then((res)=>{
                if(res.success){
                    this.enterPriseInfo = res.data.enterPriseInfo;
                }
            });
            findProvidersInfo().then((res)=>{
                this.storeInfo = res.data;
                let uuid = '/' + res.data.uuid;
                let enterPriseId = '/' + res.data.enterPriseId;
                this.uuid = uuid;
                this.enterPriseId = enterPriseId
            })
        },
        findMaterialCount(){
            findMaterialCount().then((res)=>{
                this.materialCount = res.data
            })
        },
        findServiceabilityCount(){
            findServiceabilityCount().then((res)=>{
                this.serviceabilityCount = res.data
            })
        },
        findStoreFollowCount(){
            findStoreFollowCount().then((res)=>{
                this.storeFollowCount = res.data
            })
        }
    }
}
</script>

<style scoped lang="less">
.noNumber {
    margin: 15px;
    font-size: 14px;
}
.homePageBox{
    padding: 20px;
    .homePageContent{
        display: flex;
        .pageRight{
            max-width: 610px;
            padding-left: 30px;
            padding-right: 30px;
            .tasksList{
                width: 100%;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                margin-bottom: 30px;
                padding-bottom: 20px;
                .tasksTitle{
                    border-bottom: 1px solid #ddd;
                    padding: 15px 20px;
                    h3{
                        margin: 0;
                        font-size: 16px;
                        padding-right: 20px;
                    }
                }
                .listContent{
                    ul{
                        padding: 15px 20px 0;
                        li{
                            line-height: 50px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .content{
                                position: relative;
                                padding-left: 20px;
                                max-width: 260px;
                                overflow: hidden;
                                -ms-text-overflow: ellipsis;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                font-size: 14px;
                                .point{
                                    position: absolute;
                                    width: 7px;
                                    height: 7px;
                                    border-radius: 50%;
                                    background: #000;
                                    left: 0;
                                    top: 22px;
                                }
                            }
                            .date{
                                font-size: 14px;
                                color: #b1b2b2;
                            }
                        }
                    }
                }
            }
            .settlementCenter{
                width: 100%;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                margin-bottom: 30px;
                padding-bottom: 20px;
                .settlementTitle{
                    border-bottom: 1px solid #ddd;
                    padding: 15px 20px;
                    h3{
                        margin: 0;
                        font-size: 16px;
                        padding-right: 20px;
                    }
                }
                .settlementContent{
                    padding: 30px 80px 0;
                    .settlementItem{
                        display: flex;
                        align-items: center;
                        padding-bottom: 15px;
                        .name{
                            min-width: 100px;
                            font-size: 14px;
                        }
                        .content{
                            color: #6a8bf5;
                        }
                    }
                    button{
                        display: block;
                        margin: 15px auto 0;
                        padding: 8px 15px;
                        background: #1572cf;
                        color: #fff;
                    }
                }
            }
            .storeProfile{
                width: 100%;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                margin-bottom: 30px;
                .storeTitle{
                    border-bottom: 1px solid #ddd;
                    padding: 15px 20px;
                    h3{
                        margin: 0;
                        font-size: 16px;
                        padding-right: 20px;
                    }
                }
                .storeContent{
                    padding: 20px;
                    ul{
                        margin: 0;
                        display: flex;
                        flex-wrap: wrap;
                        li{
                            text-align: center;
                            width: 25%;
                            padding: 20px;
                            border-right: 1px solid #ddd;
                            &:nth-of-type(4n){
                                border-right: none;
                            }
                            &:nth-of-type(1),&:nth-of-type(2),&:nth-of-type(3),&:nth-of-type(4){
                                border-bottom: 1px solid #ddd;
                            }
                            .name{
                                color: #a9a9a9;
                                font-size: 14px;
                                padding-bottom: 10px;
                            }
                            .num{
                                color: #568bf4;
                                font-weight: 700;
                            }
                        }
                    }
                }
            }
        }
        .pageLeft{
            flex: 1;
            min-width: 850px;
            .basicInformation{
                padding: 30px 20px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                margin-bottom: 30px;
                .infoTop{
                    display: flex;
                    justify-content: space-between;
                    .topLeft{
                        display: flex;
                        img{
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                            align-items: center;
                            margin-right: 10px;
                        }
                        .companyName{
                            font-size: 16px;
                            font-weight: 700;
                            color: #000;
                        }
                        button{
                            margin-left: 10px;
                            padding: 5px 10px;
                            font-size: 12px;
                            border-radius: 20px;
                            i{
                                vertical-align: text-bottom;
                                padding-right: 5px;
                            }
                        }
                        .companyPhone{
                            padding-top: 10px;
                            font-size: 14px;
                            color: #b0b4b8;
                        }
                    }
                }
                .topRight{
                    ul{
                        margin: 0;
                        display: flex;
                        li{
                            padding: 0 30px;
                            text-align: center;
                            .grade{
                                color: #000;
                                font-weight: 700;
                            }
                            .name{
                                padding-top: 5px;
                                color: #7f7f7f;
                            }
                        }
                    }
                }
                .infoButton{
                    margin-top: 30px;
                    ul{
                        margin: 0;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        li{
                            text-align: center;
                            .num{
                                font-size: 20px;
                                color: #4b7cf3;
                                font-weight: 700;
                            }
                            .name{
                                padding-top: 10px;
                                color: #4b7cf3;
                            }
                        }
                    }
                }
            }
            .salesInformation{
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                border-radius: 10px;
                margin-bottom: 30px;
                .salesTop{
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #ddd;
                    padding: 15px 20px;
                    h3{
                        margin: 0;
                        font-size: 16px;
                        padding-right: 20px;
                    }
                    .date{
                        font-size: 14px;
                        color: #a4a3a3;
                    }
                }
                .salesBottom{
                    padding: 30px 20px;
                    ul{
                        margin: 0;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        li{
                            .num{
                                padding: 10px 0;
                                font-size: 25px;
                                color: #000;
                            }
                            .name{
                                font-size: 14px;
                                color: #7f7f7f;
                            }
                        }
                    }
                }
            }
            .salesRanking{
                .rankingTitle{
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                    border-radius: 10px;
                    display: flex;
                    justify-content: space-between;
                    .rankingTop{
                        padding: 15px 20px;
                        width: 50%;
                        h3{
                            margin: 0;
                            font-size: 16px;
                        }
                    }
                }
                .rankingList{
                    display: flex;
                    ul{
                        padding: 30px 20px;
                        margin: 0;
                        width: 50%;
                        li{
                            display: flex;
                            padding: 15px 15px 15px 50px;
                            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                            margin-bottom: 20px;
                            border-radius: 10px;
                            position: relative;
                            align-items: center;
                            .name{
                                width: 95%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                color: #000;
                            }
                            .price{
                                padding-top: 10px;
                                color: #a9a3a9;
                                font-size: 14px;
                            }
                            .info{
                                width: 100%;
                            }
                            .img{
                                padding-right: 15px;
                                img{
                                    width: 42px;
                                    height: 42px;
                                }
                            }
                            .triangle {
                                width: 0;
                                height: 0;
                                border-top: 50px solid #cadbf7;
                                border-right: 50px solid transparent;
                                position: absolute;
                                left: 0;
                                top: 0;
                            }
                            .sort{
                                position: absolute;
                                left: 11px;
                                top: 8px;
                                color: #8f97e1;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }
    }
    .footer{
        text-align: center;
        font-size: 14px;
        color: #949494;
        p{
            span{
                padding: 0 20px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/homePage.vue